// extracted by mini-css-extract-plugin
export var title = "ExpeditionTeamMemberCard-module--title--537e0";